import { Injectable } from '@angular/core';
import { WhatsAppLogDataService } from '../data-services/whatsapp-log-data.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';

@Injectable({
  providedIn: 'root'
})
export class WhatsAppLogService {
  constructor(private whatsAppLogDataService: WhatsAppLogDataService,
    private secureStorage: SecureStorage) { }

  setUnrepliedMessageFilter() {
    this.secureStorage.setKeyData("IsReplied", true);
  }

  getUnrepliedMessageFilter(): any {
    const data = this.secureStorage.getKeyData("IsReplied");
    this.secureStorage.removeKey("IsReplied");
    return data;
  }

  sendMessage(model: any): Promise<any> {
    return this.whatsAppLogDataService.SendMessage(model);
  }

  getMessages(appointmentId: number): Promise<any> {
    return this.whatsAppLogDataService.GetMessages(appointmentId);
  }
  
  getUnrepliedWhatsAppMessages(): Promise<any> {
    return this.whatsAppLogDataService.GetUnrepliedWhatsAppMessages();
  }
}
